module.exports = __webpack_public_path__ + "img/sangeetat.b3c47f88.jpg";